import { SpreadsheetProvider } from './spreadsheet/spreadsheet.context';
import { ViewModeProvider } from './view-mode.context';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <ViewModeProvider>
      <SpreadsheetProvider>{children}</SpreadsheetProvider>
    </ViewModeProvider>
  );
}
